import FLSApiClient from '../../common/FLSApiClient';
import config from '../../config';
import { UpdateUserInterestsPayload } from './UpdateUserInterestsPayload';

export const GetInterestsList = (language: string): Promise<any> => {
  const domain = config.FLS_API_DOMAIN || '';

  const requestRegisterOptions = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  return fetch(domain + '/api/Profile/InterestsList?language=' + language, requestRegisterOptions);
};

export const GetUserInterests = (sessionId: string): Promise<any> => {
  return FLSApiClient.get('/api/Profile/Interests', {
    params: {
      sessionId: sessionId,
    },
  });
};

export const UpdateUserInterests = (sessionId: string, payload: UpdateUserInterestsPayload): Promise<any> => {
  return FLSApiClient.put('/api/Profile/Interests', {
    SessionId: sessionId,
    ...payload,
  });
};
